var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var BookOpen = function BookOpen(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m19 16.402-6 1.348V7.597l6-1.347v10.152ZM5 6.25l6 1.347V17.75l-6-1.348V6.25Zm15.625-2.032a1.003 1.003 0 0 0-.845-.194L12 5.772 4.22 4.024A.999.999 0 0 0 3 5v12.202c0 .468.324.873.78.975l8 1.798a.977.977 0 0 0 .44 0l8-1.798a.998.998 0 0 0 .78-.975V5c0-.304-.138-.59-.375-.782Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default BookOpen;